/* chevron.icon.svg.js */

"use strict";

module.exports = {
    icon: `
            <svg viewBox="0 0 30 16" preserveAspectRatio="none">
                <polygon class="foreground-gl" points="30,1.5 14,16 0,1.5 1.5,0.1 14.1,13.2 28.6,0 "/>
            </svg>
         `,
};
